<template>
    <div
        data-sticky-nav
        class="responsiveSection xmoHighlightsNavigation">
        <div class="responsiveSection__grid">
            <ul
                data-observe-navigation
                class="xmoHighlightsNavigation__list">
                <li
                    v-show="!isMaxSectionsLength"
                    class="xmoHighlightsNavigation__listTitle">
                    <span class="hl-module margin-bottom-0 text-color--dark-blue-gray">
                        {{ trans('COLLECTION_CONTENT_HEADLINE') }}
                    </span>
                    <svg
                        class="xmoHighlightsNavigation__chevronSvg"
                        aria-hidden="true">
                        <use href="#iconChevronRightSmallBold" />
                    </svg>
                </li>
                <li
                    v-for="(item, index) in sections"
                    :key="`highlightsNavigationItem__${ item.sectionKey }`">
                    <a
                        :data-nav-id="item.sectionKey"
                        class="xmoHighlightsNavigation__item"
                        :data-status="index === 0 ? 'active' : ''"
                        :href="`#${ item.sectionKey }`"
                        :data-gtm="`highlightsNavigationItem__${ item.name }`">
                        {{ getSectionTitle(item.title) }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { isMobile } from 'tools/isMobile';
    import Translator from 'tools/trans';

    const MAX_SECTIONS_LENGTH = 7;

    export default {
        data() {
            return {
                FMO: 'fmo highlights',
                sections: [
                    {
                        title: Translator.trans('XMO_HIGHLIGHTS_OVERVIEW'),
                        name: 'overview',
                        sectionKey: 'overview',
                    },
                    {
                        title: Translator.trans('XMO_KEYTAKEAWAYS_TITLE'),
                        name: 'highlights',
                        sectionKey: 'highlights',
                    },
                    {
                        title: Translator.trans('OUTLOOK_MARKETOVERVIEW_TITLE'),
                        name: 'marketDirectory',
                        sectionKey: 'marketDirectory',
                    },
                    {
                        title: Translator.trans('OUTLOOK_METHODOLOGY_TITLE'),
                        name: 'methodology',
                        sectionKey: 'methodology',
                    },
                ],
            };
        },
        computed: {
            ...mapState([
                'marketData',
            ]),
            isMaxSectionsLength() {
                return this.sections.length > MAX_SECTIONS_LENGTH;
            },
        },
        methods: {
            trans: Translator.trans,
            isMobile,
            mergeSections() {
                this.sections.splice(2, 0, ...this.marketData.sections);
            },
            getSectionTitle(title) {
                if (title === Translator.trans('XMO_HIGHLIGHTS_MARKET_REVENUE')) {
                    return Translator.trans('XMO_HIGHLIGHTS_KPI');
                }
                if (title === Translator.trans('XMO_HIGHLIGHTS_MARKET_SHARES')) {
                    return Translator.trans('XMO_HIGHLIGHTS_MARKET_PENETRATION');
                }

                return title;
            },
            appendReleaseCalendar() {
                if (this.marketData.market.name !== this.FMO) {
                    this.sections.push({
                        title: Translator.trans('GCS_HUBPAGE_RELEASES_HEADLINE'),
                        name: 'upcomingReleases',
                        sectionKey: 'upcomingReleases',
                    });
                }
            },
        },
        mounted() {
            this.appendReleaseCalendar();
            this.mergeSections();
        },
    };
</script>
